export const automationConfig = {
  n8n: {
    baseUrl: import.meta.env.VITE_N8N_URL || 'http://localhost:5678',
  },
}
